import { Link } from "react-router-dom";
import herobg from "../..//assets/images/all-img/v4/hero-bg.png";
import herothum1 from "../../assets/images/all-img/v4/hero-thumb1.png";
import herothum2 from "../../assets/images/all-img/v4/hero-thumb2.png";
import herothum3 from "../../assets/images/all-img/v4/hero-thumb3.png";
import herothum4 from "../../assets/images/all-img/v4/hero-thumb4.png";
import starblack2 from "../../assets/images/all-img/v4/star-black-2.png";
import herov2shape1 from "../../assets/images/shape2/hero-v2-shape1.png";
import herov2shape2 from "../../assets/images/shape2/hero-v2-shape2.png";

export default function HeroSection() {
	return (
		<div
			className="fugu--hero-section fugu--hero-section2"
			style={{ backgroundImage: `url(${herobg})` }}
		>
			<div className="container">
				<div className="fugu--hero-content fugu--hero-content2">
					<h1 className="wow fadeInUpX" data-wow-delay="0s">
						Discover digital art, collect & sell NFT
					</h1>
					<p className="wow fadeInUpX" data-wow-delay=".10s">
						Nexto is the largest NFT marketplace. There are enough digital artworks available online that
						make NFTs easier and more efficient for you.
					</p>
					<div className="fugu--btn-wrap fugu--hero-btn wow fadeInUpX" data-wow-delay=".20s">
						<Link to={"#"}  >
							<a className="fugu--btn bg-orange">View All Collections</a>
						</Link>
					</div>
					<div className="fugu--content-star">
						<img src={starblack2} alt="" />
					</div>
					<div className="fugu--hero-mocup mocup1">
						<img src={herothum1} alt="" />
					</div>
					<div className="fugu--hero-mocup mocup2">
						<img src={herothum2} alt="" />
					</div>
					<div className="fugu--hero-mocup mocup3">
						<img src={herothum3} alt="" />
					</div>
					<div className="fugu--hero-mocup mocup4">
						<img src={herothum4} alt="" />
					</div>
				</div>
			</div>
			<div className="fugu--hero-shpae1">
				<img src={herov2shape1} alt="" />
			</div>
			<div className="fugu--hero-shpae2">
				<img src={herov2shape2} alt="" />
			</div>
		</div>
	);
}
